import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/beantragte-verfahren/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierGoodRequestedProcess"
      returnRoute="/auswahlfelder/dossierGoodRequestedProcess"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierGoodRequestedProcessRoute = Route;
